import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { Pagination, Navigation } from "swiper/modules";
import { useAppDispatch, useAppSelector } from "../../../../../app/redux/hooks";
import { getDecryptedToken } from "../../../../../app/auth/authHandler";
import CategoriesSwiperSkeleton from "../../landingPage/components/skeletons/CategoriesSkeleton";
import { useEffect, useState ,useRef} from "react";
import { getPeopleBaughtListAsync } from "../../../../../app/slices/productList/productListingSlice";
import { setSelectProduct } from "../../../../../app/slices/productDiscriptionSlice/ProductDescriptionSlice";
import { showSnackbar } from "../../../../../app/slices/common/customSnackBar/customSnackbarSlice";
import { getProductImageUrl } from "../../../../../app/slices/common/imageConstants";
import {
  addToWisshListAsync,
  removeFromWishListAsync,
} from "../../../../../app/slices/wishlistSlice/wishlistSlice";
import { Link } from "react-router-dom";
import CustomDialog from "../../../../components/custom/dialog";
import { QuickAddModal } from "../../productListPage/components/quickAdd/quickAdd";
import { CircularProgress } from "@mui/material";

export const PeopleAlsoBought = () => {
  // const productList = useAppSelector(
  //   (state) => state.productTypesState.productTypes
  // );
  const dispatch = useAppDispatch();
  const [peopleBaughtList, setPeopleBaughtList] = useState<any[]>([]);
  const { addTocart } = useAppSelector((state) => state.CartState);
  const [modalType, setModalType] = useState("");
  const isLoading = useAppSelector(
    (state) => state.ProductsListState.peopleBaughtList.loader
  );
  const didFetch = useRef(false);
  
  useEffect(() => {
    if (didFetch.current) return; // skip second call in StrictMode
    didFetch.current = true;
  
    if (!addTocart?.data || addTocart.data.length === 0) return;
  
      const aId = localStorage.getItem("aId");
      const accessToken = getDecryptedToken();
      const anonymous_id = accessToken ? null : aId ? aId : null;
      const product_id = localStorage.getItem("product_id");
      dispatch(getPeopleBaughtListAsync({ anonymous_id, product_id })).then(
        (response: any) => {
          const data = response.payload?.data;
          setPeopleBaughtList(data?.products);
        }
      );
    
  }, [addTocart?.data, dispatch]);
  const selectProduct = (id: any) => {
    dispatch(setSelectProduct(id));
    localStorage.setItem("product_id", id);
  };

  const handleAddToWishList = (productId: any) => {
    const accessToken = getDecryptedToken();
    if (accessToken) {
      const updatedProducts = peopleBaughtList.map((product: any) =>
        product.product_id === productId
          ? { ...product, wishlist: true }
          : product
      );
      setPeopleBaughtList(updatedProducts);
      addToWishList(productId);
    } else {
      dispatch(
        showSnackbar({
          message: "Please login to create wishlist",
          severity: "error",
          autoHide: 2000,
        })
      );
    }
  };

  const handleRemoveFromWishList = (productId: any) => {
    const updatedProducts = peopleBaughtList.map((product: any) =>
      product.product_id === productId
        ? { ...product, wishlist: false }
        : product
    );

    setPeopleBaughtList(updatedProducts);
    removeFromWishList(productId);
  };
  const addToWishList = (id: any) => {
    dispatch(addToWisshListAsync(id));
  };
  const removeFromWishList = (id: any) => {
    dispatch(removeFromWishListAsync(id));
  };
  const onOpenModal = (type: string) => {
    setModalType(type);
  };
  const onCloseModal = () => {
    setModalType("");
  };
  const percentageDisplay = (offer: any) => {
    if (!offer) {
      return null;
    }
    const percentage = parseFloat(offer.replace("%", ""));

    const formattedPercentage =
      percentage % 1 === 0
        ? `${Math.round(percentage)}%`
        : `${percentage.toFixed(2)}%`;

    return formattedPercentage;
  };
  return (
    <>
      {/* {peopleBaughtList?.loader ? (
        <CategoriesSwiperSkeleton />
      ) : ( */}

      <section className="pb_0">
        <div className="container" style={{ margin: "1rem" }}>
          {isLoading ? (
            <>
              <div className="hover-sw-nav" style={{ minHeight: "50vh" }}>
                <CircularProgress
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                />
              </div>
            </>
          ) : (
            <>
              {peopleBaughtList?.length > 0 && (
                <>
                  <div className="flat-title">
                    <span className="title wow fadeInUp" data-wow-delay="0s">
                      People Also Bought
                    </span>
                  </div>
                  <div className="hover-sw-nav">
                    <Swiper
                      freeMode={true}
                      navigation={{
                        nextEl: ".nav-next-slider",
                        prevEl: ".nav-prev-slider",
                      }}
                      pagination={{
                        el: ".sw-dots",
                        clickable: true,
                      }}
                      breakpoints={{
                        1024: { slidesPerView: 4, spaceBetween: 10 },
                        768: { slidesPerView: 2, spaceBetween: 15 },
                        480: { slidesPerView: 2, spaceBetween: 15 },
                      }}
                      modules={[Pagination, Navigation]}
                      className="mySwiper"
                    >
                      {peopleBaughtList?.map((item: any, index: any) => (
                        <SwiperSlide key={index}>
                          <div className="card-product fl-item">
                            <div className="card-product-wrapper">
                              <Link
                                to={`/products/${item.product_id}`}
                                onClick={() => selectProduct(item?.product_id)}
                              >
                                <span className="product-img">
                                  <img
                                    className="lazyload img-product"
                                    data-src={getProductImageUrl(item?.product_img)}
                                    src={getProductImageUrl(item?.product_img)}
                                    alt="image-product"
                                  />
                                  <img
                                    className="lazyload img-hover"
                                    data-src={getProductImageUrl(item?.product_img)}
                                    src={getProductImageUrl(item?.product_img)}
                                    alt="image-product"
                                  />
                                </span>
                              </Link>
                              <div className="list-product-btn absolute-2">
                                <a
                                  onClick={() => {
                                    onOpenModal("quickAdd");
                                    selectProduct(item?.product_id);
                                  }}
                                  className="box-icon bg_white quick-add tf-btn-loading"
                                >
                                  <span className="icon icon-bag"></span>
                                  <span className="tooltip">Add to Bag</span>
                                </a>
                                <span
                                  className="box-icon bg_white wishlist btn-icon-action"
                                  onClick={() => {
                                    if (item?.wishlist !== true) {
                                      handleAddToWishList(item?.product_id);
                                    } else {
                                      handleRemoveFromWishList(
                                        item?.product_id
                                      );
                                    }
                                  }}
                                >
                                  {item?.wishlist !== true ? (
                                    <span className="icon icon-heart"></span>
                                  ) : (
                                    <span className="icon icon-delete"></span>
                                  )}
                                  <span className="tooltip">
                                    {item?.wishlist !== true
                                      ? "Add to Wishlist"
                                      : "Remove from Wishlist"}
                                  </span>
                                </span>
                              </div>
                              <div className="on-sale-wrap text-end">
                                {item?.offer && item.offer !== "0%" && (
                                  <div className="on-sale-item">
                                    OFF {percentageDisplay(item?.offer)}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="d-flex justify-content-between align-items-end">
                              <div className="card-product-info">
                                <Link
                                  to={`/products/${item.product_id}`}
                                  className="title link"
                                >
                                  <span
                                    onClick={() =>
                                      selectProduct(item?.product_id)
                                    }
                                  >
                                    {item?.product_name}
                                  </span>
                                </Link>
                              </div>
                              <div
                                className="variant-picker-item"
                                style={{ marginTop: "1rem" }}
                              >
                                <div
                                  className="variant-picker-values"
                                  style={{
                                    height: "20px",
                                    marginRight: "1rem",
                                  }}
                                >
                                  <input
                                    id="values-veg"
                                    type="radio"
                                    name="color1"
                                    checked
                                    readOnly
                                  />
                                  <label
                                    className={`hover-tooltip  ${
                                      item?.product_type === "Veg"
                                        ? "veg"
                                        : "nonveg"
                                    }`}
                                    htmlFor="values-veg"
                                    data-value="Veg"
                                  >
                                    <span
                                      className={`btn-checkbox    ${
                                        item?.product_type === "Veg"
                                          ? "bg-color-veg bg-veg"
                                          : "bg-color-nonveg "
                                      }`}
                                    ></span>
                                    <span className="tooltip">
                                      {item?.product_type}
                                    </span>
                                  </label>{" "}
                                </div>
                              </div>
                            </div>
                            <div className="tf-product-info-price mt-1">
                              <div className="price fs-14 fw-6">
                                {item?.offerprice}
                              </div>
                              <div className="compare-at-price fs-14">
                                {item?.offer && item.offer !== "0%" && (
                                  <span>{item?.price}</span>
                                )}
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>

                    <div className="nav-sw nav-next-slider box-icon w_46 round">
                      <span className="icon icon-arrow-left"></span>
                    </div>
                    <div className="nav-sw nav-prev-slider box-icon w_46 round">
                      <span className="icon icon-arrow-right"></span>
                    </div>

                    <div className="sw-dots style-2 sw-pagination-collection justify-content-center"></div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </section>

       {modalType === "quickAdd" && <CustomDialog
        component={<QuickAddModal modalType={modalType} />}
        title="Quick Add"
        openDialog={modalType === "quickAdd"}
        handleCloseDialog={onCloseModal}
        modalPlace="center"
      />}
    </>
  );
};
